import { makeAutoObservable } from 'mobx';

export class ErrorNotiUiStore {
  visible: boolean;

  content: string;

  constructor() {
    this.visible = false;
    this.content = 'Service Failed';

    makeAutoObservable(this);
  }

  open = (content: string) => {
    this.content = content ?? 'Service Failed';

    this.visible = true;
  };

  close = () => {
    this.visible = false;
  };
}
